import axios from 'axios';

export default class Api {

  baseUrl = 'https://b2b-ext.acko.ru/';
  //baseUrl = 'https://b2b-ext.acko.tech/';

  constructor() {
    this.web = axios.create({
      baseURL: this.baseUrl,
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
      }
    });
  }

  login(username, password) {
    return new Promise((resolve, reject) => {
      this.web.post('api/login',{username, password})
          .then((response) => {
            if (response) {
              resolve(response.data);
            }
          })
          .catch((err) => {
            reject(err);
          });
    });
  }

  refreshToken(token) {
    return new Promise((resolve, reject) => {
      this.web.post('api/token/refresh',{token})
          .then((response) => {
            if (response) {
              resolve(response.data);
            }
          })
          .catch((err) => {
            reject(err);
          });
    });
  }

  /**
   * Получение справочников
   */
  initialize(token) {
    return new Promise((resolve, reject) => {
      this.web.post('api/jugoria-dvs/sport/agr-calc',{data: null}, {
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': `Bearer ${token}`,
        }})
          .then((response) => {
            if (response) {
              resolve(response.data);
            }
          })
          .catch((err) => {
            reject(err);
          });
    });
  }
  /**
   * Получение справочников по катировке
   */
  infoById(id, token) {
    return new Promise((resolve, reject) => {
      this.web.post(`api/jugoria-dvs/agr-calc/${id}`,{}, {
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': `Bearer ${token}`,
        }})
          .then((response) => {
            if (response) {
              resolve(response);
            }
          })
          .catch((err) => {
            reject(err);
          });
    });
  }
  /**
   * Сохранение результатов расчёта по катировке
   */
  save(id, data, token) {
    return new Promise((resolve, reject) => {
      this.web.put(`api/jugoria-dvs/agr-calc/${id}`, {params: data}, {
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': `Bearer ${token}`,
        }})
          .then((response) => {
            if (response) {
              resolve(response);
            }
          })
          .catch((err) => {
            reject(err);
          });
    });
  }
  /**
   * Создание договора
   */
  createAgreement(id, token, data) {
    return new Promise((resolve, reject) => {
      this.web.post(`api/jugoria-dvs/agr-calc/${id}/create-agreement`, {params: data}, {
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': `Bearer ${token}`,
        }})
          .then((response) => {
            if (response) {
              resolve(response);
            }
          })
          .catch((err) => {
            reject(err);
          });
    });
  }
  /**
   * Добавление информации о страхуемых
   */
  saveObjects(id, dateBegin, data, token) {
    return new Promise((resolve, reject) => {
      this.web.post(`api/jugoria-dvs/agr/${id}/objects`, {dateBegin, objects: data}, {
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': `Bearer ${token}`,
        }})
          .then((response) => {
            if (response) {
              resolve(response);
            }
          })
          .catch((err) => {
            reject(err);
          });
    });
  }

  /**
   * Получение расчёта по катировке
   */
  calculate(id, token) {
    return new Promise((resolve, reject) => {
      this.web.post(`api/jugoria-dvs/agr-calc/${id}`, {},{
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': `Bearer ${token}`,
        }})
          .then((response) => {
            if (response) {
              resolve(response);
            }
          })
          .catch((err) => {
            reject(err);
          });
    });
  }

  /**
   * Подпись договора
   */
  verify(id, email, token) {
    return new Promise((resolve, reject) => {
      this.web.post(`api/jugoria-dvs/agr/${id}/verify`, {email: email}, {
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': `Bearer ${token}`,
        }})
          .then((response) => {
            if (response) {
              resolve(response);
            }
          })
          .catch((err) => {
            reject(err);
          });
    });
  }

  /**
   * Отправка кода подтверждения
   */
  emailVerify(id, data, token) {
    return new Promise((resolve, reject) => {
      this.web.put(`api/jugoria-dvs/agr/${id}/verify`, data, {
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': `Bearer ${token}`,
        }})
          .then((response) => {
            if (response) {
              resolve(response);
            }
          })
          .catch((err) => {
            reject(err);
          });
    });
  }

  /**
   * Отправка примера договора на почту
   */
  sendExample(id, token) {
    return new Promise((resolve, reject) => {
      this.web.post(`api/jugoria-dvs/agr/${id}/send`, {}, {
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': `Bearer ${token}`,
        }})
          .then((response) => {
            if (response) {
              resolve(response);
            }
          })
          .catch((err) => {
            reject(err);
          });
    });
  }

  /**
   * Запрос и переадресация ссылки на оплату
   */
  finish(id, data, token) {
    return new Promise((resolve, reject) => {
      this.web.post(`api/jugoria-dvs/agr/${id}/payment`, data, {
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': `Bearer ${token}`,
        }})
          .then((response) => {
            if (response) {
              resolve(response);
            }
          })
          .catch((err) => {
            reject(err);
          });
    });
  }
}